<template>
  <DxDataGrid
    id="dataGrid"
    ref="table"
    :data-source="data"
    :repaint-changes-only="true"
    :two-way-binding-enabled="false"
    :allow-column-resizing="$store.getters.locked"
    :allowColumnReordering="$store.getters.locked"
    :selection="{ mode: selectionMode }"
    @selection-changed="selectionChanged"
    :show-borders="true"
    column-resizing-mode="nextColumn"
    
    @context-menu-preparing="contextMenu"
    @rowPrepared="rowPrepared"
    :row-alternation-enabled="true"
  >
    <DxPaging :enabled="pageSize != -1" :page-size="pageSize" />
  </DxDataGrid>
</template>

<script>
import { DxDataGrid, DxPaging } from "devextreme-vue/data-grid";

export default {
  components: {
    DxDataGrid,
    DxPaging,
  },

  props: {
    columns: {
      required: true,
      value: Array,
    },

    data: {
      required: true,
      type: Object,
    },

    groupedBy: {
      required: false,
      value: String,
    },

    pageSize: {
      required: true,
      value: Object,
    },

    colorDict: {
      required: false,
      value: Object,
    },

    contextMenu: {
      required: false,
      value: Function,
      default: () => () => {},
    },

    rowPrepared:{
      required: false,
      value: Function,
      default: () => () => {}
    },

    selectionMode: {
      required: false,
      type: String,
      value: () => "none",
    },
  },

  beforeCreate() {
    this.$eventHub.$on("saving", () => this.storeColumns());
  },

  mounted() {
    this.$refs.table.instance.option("columns", this.getCols());
  },

  watch: {
    columns() {
      this.$refs.table.instance.option("columns", this.getCols());
    },

    data() {
      this.$refs.table.instance.option("dataSource", this.data);
      this.refresh();
    },
  },

  beforeDestroy() {
    this.$eventHub.$off("saving");
  },

  computed: {
    colWidths() {
      return this.$refs.table.instance.state().columns.map((x) => x.width);
    },
  },

  methods: {
    getCols() {
      var vue = this;
      var cols = this.columns.map((x) => ({
        caption: x.label,
        dataField: x.field,
        alignment: "left",
        ...(x.width != 0 && { width: x.width }),
        ...(x.visible != undefined && { visible: false }),
        cellTemplate(container, options) {
          if(x.label == "Break Reason") {
            var p = document.createElement("p")
            var reason = vue.$diamond.breakReasons[options.value]
            p.innerText = reason === undefined ? "Unknown" : reason
            container.appendChild(p)
          }
          else if (!x.color) container.innerHTML = options.value;
          else container.appendChild(vue.createColorCircle(options.data[""]));
        },
      }));

      if (this.groupedBy) {
        var index = cols.findIndex((x) => x.dataField == this.groupedBy);
        if (index != -1) {
          cols[index].groupIndex = 0;
        }
      }
      return cols;
    },

    createColorCircle(state) {
      var div = document.createElement("div");
      var colorIndex = this.colorDict.findIndex((x) => x.state == state);
      div.style.cssText = `
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
            `;
      var colorDiv = document.createElement("div");
      colorDiv.style.cssText = `
                width: 16px;
                height: 16px;
                border-radius: 100%;
                min-width: 16px;
                background-color: ${this.colorDict[colorIndex].color}
            `;
      div.appendChild(colorDiv);
      return div;
    },

    refresh() {
      this.$refs.table.instance.refresh();
    },

    selectionChanged(ev) {
      var row = ev.selectedRowsData[0];
      this.$emit("selection-changed", row);
    },

    storeColumns() {
      if (!this.$refs.table) return;
      var cols = this.$refs.table.instance.state().columns;
      if (!cols) return;
      var ordered = cols
        .sort((a, b) => a.visibleIndex - b.visibleIndex)
        .map((x) => ({
          field: x.dataField,
          width: x.width,
        }));
      this.$emit("columns-changed", ordered);
    },
  },
};
</script>

<style scoped>
</style>
